import { Component } from 'react';
import Footer from "../Footer";

class FooterFR extends Component {
    render() {
      return (
          
        <Footer 
            contact={{
                title:"vous pouvez nous contacter", 
                email: { key:"Courriel", value:"info@coeladvocaten.be" },
                lines: [
                    { text:"" },      
                    { text:"Tel : +32 15 41 76 36"},
                    { text:"Fax : +32 15 43 21 55"},
                    { text:"" },                                                    
                    { text:"Nos bureaux sont ouverts de 8h30 à 17h30" },
                    { text:"Consultation uniquement sur rendez-vous" },
                    { text:"" },
                    { text:"SRL Frank Coel Avocat"},
                    { text:"Schuttersvest 78, 2800 Malines"},
                    { text:"BCE: BE 0861.086.519" },
                ]
            }}

            info={{
                title:"Information légale", 
                lines: [
                    { text:"Les avocats sont inscrits au Barreau de la province d'Anvers." },
                    { text:"" },
                    { text:"Les avocats sont assurés en responsabilité professionnelle auprès d'Amlin Europe NV, via Vanbreda Risk & Benefits avec le numéro de police LXX034899." },
                    { text:"" },
                    { text:"Cette assurance offre une garantie de 1 250 000,00 euros par sinistre."},
                    { text:"" },
                    { text:"Le client est responsable de fournir toutes les informations relatives à  son dossier, la confidentialité des informations étant couverte par le secret professionnel de l'avocat."},
                ]
            }}

            links={{
                title:"Liens utiles", 
                items: [
                    { url:"/fr", name:"Accueil" },
                    { url:"/fr/frank-coel", name:"Frank Coel" },
                    { url:"/fr/anna-mamchenkova", name:"Anna Mamchenkova" },
                    { url:"/fr/entreprises-en-difficultes", name:"Entreprises en difficultés" },
                    { url:"/fr/conseils-defense-litiges", name:"Conseils, défense et litiges" },
                    { url:"/fr/presse", name:"Presse" },
                    { url:"/fr/conditions-generales", name:"Tarifs & Honoraires" },
                    { url:"/fr/contact", name:"Contact" },
                ]
            }}

            articles={{
                title:"Presse", 
                items: [
                    { url:"/fr/presse#1", name:"Un membre du parti de Somers dirige la protestation contre le parking Schuttersvest" },
                    { url:"/fr/presse#2", name:"La pollution des sols peut arrêter la construction du parking Schuttersvest" },
                    { url:"/fr/presse#3", name:"Un incendie volontaire pour venger sa sœur Olga" },
                    { url:"/fr/presse#4", name:"Enfant sans papiers (10) et sans famille dans une cellule de police" },
                    { url:"/fr/presse#5", name:"Le dossier de Kucam est fondé sur des rumeurs" },
                    { url:"/fr/presse#6", name:"Un certain Frank, du parlement, organise l'obtention de visas contre paiement" },
                ]
            }}

            condition={{ url:"/fr/conditions-generales", name:"Conditions générales" }}
            privacy={{ url:"/fr/declaration-de-confidentialite", name:"Politique de confidentialité" }}
            copyright="COELADVOCATEN - 78, Schuttersvest, 2800 Malines, Belgique"
            designer={{ url:"https://www.bewive.be", name:"Créé par Bewive", alt:"Vers le site du fournisseur" }}
            cookies={{ url:"/fr/declaration-de-confidentialite", name:"politique de confidentialité", text:"En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies", button:"J'accepte" }}
        />
          
      );
    }
  }
  
  export default FooterFR
